var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function setCookie(name, value, attributes) {
    if (attributes === void 0) { attributes = {}; }
    if (typeof document === 'undefined') {
        return;
    }
    var domain = attributes.domain, _a = attributes.path, path = _a === void 0 ? '/' : _a, maxAgeSeconds = attributes.maxAgeSeconds, _b = attributes.sameSite, sameSite = _b === void 0 ? 'Lax' : _b, secure = attributes.secure;
    var parts = ["".concat(name, "=").concat(encodeURIComponent(value)), "path=".concat(path), "SameSite=".concat(sameSite)];
    if (domain) {
        parts.push("domain=".concat(domain));
    }
    if (maxAgeSeconds !== undefined) {
        parts.push("max-age=".concat(maxAgeSeconds));
    }
    if (secure) {
        parts.push('Secure');
    }
    document.cookie = parts.join('; ');
}
export function getCookie(name) {
    if (typeof document === 'undefined') {
        return undefined;
    }
    var prefix = "".concat(name, "=");
    var entry = document.cookie.split('; ').find(function (row) { return row.startsWith(prefix); });
    return entry ? decodeURIComponent(entry.slice(prefix.length)) : undefined;
}
export function removeCookie(name, attributes) {
    if (attributes === void 0) { attributes = {}; }
    // Wygaszenie cookie wymaga tych samych atrybutów domeny/ścieżki, z jakimi je ustawiono.
    setCookie(name, '', __assign(__assign({}, attributes), { maxAgeSeconds: 0 }));
}
